<template>
  <div class="LeavingAMessage">
      <div class="page-module animated">
          <div class="input">
              <el-input style="width: 320px" v-model="api.name" placeholder="企业名称"></el-input>
              <el-input style="width: 320px" v-model="api.linkman" placeholder="称呼"></el-input>
              <el-input style="width: 320px" v-model="api.linktel" placeholder="手机"></el-input>
          </div>
          <el-input class="textarea" v-model="api.content" placeholder="请将您的疑问记录下来。" type="textarea"></el-input>
          <input style="width:0;height:0"/>
          <el-button type="primary" @click="submit">提交留言</el-button>
      </div>
      <VerificationCode ref="verificationcode" @getVerificationCode="getVerificationCode"></VerificationCode>
      <el-dialog width="380px" :visible.sync="successDialog" :before-close="closeSuccess">
          <img style="width: 114px;margin: auto;margin-bottom: 28px" :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
          <p>您的留言提交成功，我们会在最短时间与您联系！</p>
          <el-button style="width: 280px" type="primary" @click="closeSuccess">好的，知道了。</el-button>
      </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import VerificationCode from '../components/VerificationCode.vue'
import {operateGuestNoteByCode} from 'api/gujingApi'
export default {
  name: 'LeavingAMessage',
  props: ['code'],
  data () {
    return {
        api: {
            code: this.code,    // 板块名称
            name: '',   // 企业名称
            linkman: '', // 称呼
            linktel: '', // 联系方式
            content: '', // 留言记录
            usercode: '', // (用户输入的验证码)
            codeEncryption: '',  // 加密后的验证码
            clienttype: 1
        },
        successDialog: false    // 弹窗状态
    }
  },
  mounted () {
  },
  methods: {    // 提交留言
    submit() {
        if (this.api.name === '') {
            this.$message.warning('请填写企业名称')
            return
        }
        if (this.api.linkman === '') {
            this.$message.warning('请填写称呼')
            return
        }
        if (this.api.linktel === '') {
            this.$message.warning('请填写手机号码')
            return
        }
        if (!(/^1[3456789]\d{9}$/.test(this.api.linktel))) {
            this.$message.warning('请填写正确的手机号码')
            return
        }
        if (this.api.content === '') {
            this.$message.warning('请填写您的疑问')
            return
        }

        this.$refs.verificationcode.start('提交留言')
    },
    closeSuccess() {    // 关闭弹窗
        this.successDialog = false
    },
    inifApi() { // 初始化
        this.api =  {
                        code: this.code,    // 板块名称
                        name: '',   // 企业名称
                        linkman: '', // 称呼
                        linktel: '', // 联系方式
                        content: '', // 留言记录
                        usercode: '', // (用户输入的验证码)
                        codeEncryption: '',  // 加密后的验证码
                        clienttype: 1
                    }
    },
    getVerificationCode(verificationCode, codeEncryption) { // 获取验证码回填函数
        this.api.usercode = verificationCode
        this.api.codeEncryption = codeEncryption
        this.setLoading(true)   
        operateGuestNoteByCode({    // 提交留言接口
            data: this.api,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    this.$refs.verificationcode.close()
                    this.successDialog = true
                    this.inifApi()
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      VerificationCode
  }
}
</script>

<style lang="scss" type="text/scss">
.LeavingAMessage {
    height: 454px;
    background: url("../../../common/images/gujing/equityLearning/ly.png") no-repeat center;
    background-size: 1920px 454px;
    text-align: center;
    .input {
        margin-top: 60px;
        .el-input~.el-input {
            margin-left: 110px;
        }
    }
    .el-textarea {
        margin-top: 40px;
        height: 180px;
        .el-textarea__inner {
            background: none;
            border-color: #fff !important;
            color: #fff !important;
            height: 100%;
        }
        textarea {
            &::placeholder {
                color: #fff;
            }
        }
    }
    .input {
        .el-input {
            .el-input__inner {
                background: none;
                border-color: #fff !important;
                color: #fff !important;
            }
            input {
                color: #fff !important;
                &::placeholder {
                    color: #fff;
                }
            }
        }
    }
    .el-button {
        margin-top: 30px;
        width: 180px;
    }
}
</style>